import {
  IPriceIncrease,
  INextPriceIncrease,
  IAddBuyPrice,
} from '../../types/models/Price';
import {
  FETCH_PRICE_INCREASE,
  FETCH_PRICE_INCREASE_ERROR,
  FETCH_PRICE_INCREASE_SUCCESS,
  PriceIncreaseActionTypes,
  SAVE_PRICE_INCREASE,
  SAVE_PRICE_INCREASE_ERROR,
  SAVE_PRICE_INCREASE_SUCCESS,
  FETCH_NEXT_PRICE_INCREASE,
  FETCH_NEXT_PRICE_INCREASE_ERROR,
  FETCH_NEXT_PRICE_INCREASE_SUCCESS,
  ADD_BUY_PRICE,
  ADD_BUY_PRICE_SUCCESS,
  ADD_BUY_PRICE_ERROR,
} from '../../types/actions/PriceIncrease.actions';

export interface PriceIncreaseState {
  data: IPriceIncrease | null;
  nextPrice: INextPriceIncrease | null;
  addPrice: IAddBuyPrice | null;
  isLoading: boolean;
  isSaving: boolean;
}

const initialState: PriceIncreaseState = {
  data: null,
  nextPrice: null,
  addPrice: null,
  isSaving: false,
  isLoading: false,
};

export default (
  state = initialState,
  action: PriceIncreaseActionTypes,
): PriceIncreaseState => {
  switch (action.type) {
    case FETCH_PRICE_INCREASE:
    case FETCH_NEXT_PRICE_INCREASE:
    case ADD_BUY_PRICE: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case FETCH_PRICE_INCREASE_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isSaving: false,
        data: action.payload,
      };
    }
    case SAVE_PRICE_INCREASE_SUCCESS: {
      return {
        ...state,
        isSaving: false,
        data: action.payload,
      };
    }
    case FETCH_PRICE_INCREASE_ERROR: {
      return {
        ...state,
        isLoading: false,
        isSaving: false,
        data: null,
      };
    }
    case SAVE_PRICE_INCREASE: {
      return {
        ...state,
        isSaving: true,
      };
    }
    case SAVE_PRICE_INCREASE_ERROR: {
      return {
        ...state,
        isSaving: false,
      };
    }
    case FETCH_NEXT_PRICE_INCREASE_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        nextPrice: action.payload,
      };
    }
    case FETCH_NEXT_PRICE_INCREASE_ERROR:
    case ADD_BUY_PRICE_ERROR: {
      return {
        ...state,
        isLoading: false,
      };
    }
    case ADD_BUY_PRICE_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        addPrice: action.payload,
      };
    }
    default:
      return state;
  }
};
